import { Component } from '@angular/core';

@Component({
	selector: 'app-search-sort-filter',
	templateUrl: './search-sort-filter.component.html',
	styleUrls: ['./search-sort-filter.component.scss']
})
export class SearchSortFilterComponent {}
